import { FilesTable } from "@/components/Tables/Aeros/components/FilesTable"
import type { SignedUrl } from "@/graphql/codegen/graphql"
import { useProductFilesColumns } from "@/screens/Products/components/Product/Information/ProductFiles/ProductFileTable/useProductFilesColumns"

interface ProductFileTableProps {
  data: SignedUrl[]
  isLoading: boolean
  error?: Error
  onRemove: (fileId: string) => Promise<boolean>
}

export const ProductFileTable: React.FC<ProductFileTableProps> = ({ data, isLoading, error, onRemove }) => {
  const columns = useProductFilesColumns(onRemove)

  return (
    <FilesTable
      data={data}
      isLoading={isLoading}
      columns={columns}
      error={error}
      noDataMessage='No product documents found'
    />
  )
}
